import Vue from 'vue'
import App from './App.vue'
import router from '@/router'
import store from '@/store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import "./style/scrollbar.css";
import md5 from 'js-md5';
import './style/base.css';
import VideoPlayer from 'vue-video-player';
import 'videojs-contrib-hls';
import common from './js/common.js';
import './style/iconfont.css'
import '@/js/utils/string.js';
import utils from '@/js/utils/util';
import 'lib-flexible/flexible'
import $ from 'jquery'
Vue.config.productionTip = false

require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')

//axios本版本不支持jsonp 自己拓展一个
axios.jsonp = (url,callback) => {
    if(!url){
        console.error('Axios.JSONP 至少需要一个url参数!')
        return;
    }
    return new Promise((resolve,reject) => {
        window.jsonCallBack =(result) => {
            resolve(result)
        }
        var JSONP=document.createElement("script");
        JSONP.type="text/javascript";
        JSONP.src=`${url}&callback=jsonCallBack`;
        document.getElementsByTagName("head")[0].appendChild(JSONP);
        setTimeout(() => {
            document.getElementsByTagName("head")[0].removeChild(JSONP);
        },500)
    })
}
Vue.prototype.axios = axios;
Vue.prototype.$md5 = md5;
Vue.prototype.$common = common;
Vue.prototype.$utils = utils;   //注册全局方法
Vue.use(VueAxios, axios,VideoPlayer);

new Vue({
  router,
  store,
  axios,
  render: h => h(App)
}).$mount('#app')
